module.exports = {
  entry: './src/apps/hr-calculator-government/index.tsx',
  shortcode: 'hr-calculator-gov',
  title: 'Hr Calculator Gov',
  status: 'stable',
  description: '',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-hr-calculator-government-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud', '/products', '/flashsystem'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
